module.exports = __webpack_public_path__ + "img/20191021163200360截图20191021153556103.0efd7f1a.jpg";